import * as React from 'react';

import cn from 'classnames';

import { noop } from '@utils';

import { CheckBoxContainer } from '../CheckBoxContainer';
import { ICheckBoxContainerConnectedProps } from '../CheckBoxContainer/types';

import { ISimpleCheckBoxContentProps, ISimpleCheckBoxProps } from './types';

import * as s from './SimpleCheckBox.scss';

const renderCheckBoxContent = ({ label, isDisabled, labelClassName, checkboxClassName }: ISimpleCheckBoxContentProps) =>
	// eslint-disable-next-line react/display-name
	({ isChecked }: ICheckBoxContainerConnectedProps): React.ReactNode => (
		<div className={cn(s.container, { [s.containerDisabled]: isDisabled })}>
			<div
				className={cn(
					s.checkbox,
					{
						[s.checked]: isChecked,
						[s.checkboxDisabled]: isDisabled,
					},
					checkboxClassName,
				)}
			/>
			{label && <div className={cn(s.label, labelClassName, { [s.labelDisabled]: isDisabled })}>{label}</div>}
		</div>
	);

export const SimpleCheckBox = ({ onToggle = noop, isDefaultChecked, label, isDisabled, labelClassName, checkboxClassName, ...props }: ISimpleCheckBoxProps) => (
	<CheckBoxContainer
		onToggle={onToggle}
		isDefaultChecked={isDefaultChecked}
		isDisabled={isDisabled}
		className={s.checkboxWrapper}
		render={renderCheckBoxContent({ label, isDisabled: isDisabled, labelClassName, checkboxClassName })}
		{...props}
	/>
);
